import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-account-head',
  templateUrl: './account-head.component.html',
  styleUrls: ['./account-head.component.css']
})
export class AccountHeadComponent implements OnInit {
  AccountHeadDetails: any={};
  AccountHead: any;
  mode: string;
  formSubmitted: boolean;
  s:any={};
  a:any={};
  r:any={};
  maintitle="New AccHead & SubAccHead Creation";
  title = "Add AccHead & SubAccHead List";
  accountHeadlist:any=[];
  SubHeadGridList:any=[];
  edit:any;

  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {
    
  }

  ngOnInit() {   
    // this.route.params.subscribe(params => {
      
    //   this.mode = params['mode'];
    //   this.AccountHead = params['accountHead'];      
    // });
    
     //From URL
     this.mode=localStorage.getItem('mode');
     this.AccountHead= localStorage.getItem('accounthead');
     localStorage.removeItem('accounthead'); 
     localStorage.removeItem('mode');
     
    if (this.AccountHead != null && this.mode!=null) 
    {
      this.GetAccountHeadForAccountId(this.AccountHead);
    }
    if (this.mode == 'edit')
    {
      this.maintitle="";
      this.title = "Edit Account Head";
    }
    if (this.mode == 'view')
    {
      this.maintitle="";
      this.title = "View Account Head";
    }  
    this.GetAllAccountHeads();  
    this.s.isChecked=false;
  }
//   keyPressText(event: any) {    
//     const pattern =/[A-Za-z]/;
//     let inputChar = String.fromCharCode(event.charCode);
//     var uname = new String(event.target.value)
//     if (!pattern.test(inputChar) && uname.trim().length==0)
//     {
//       event.preventDefault();
//     }
//  } 
//   keyPress(event: any) {
//     ;
//     const pattern = /[0-9]/;
//     let inputChar = String.fromCharCode(event.charCode);
//     // console.log(inputChar, e.charCode);
//     let inputChars = new Number((event.target.value + inputChar).substring(0,12));
//     var element1 = <HTMLDivElement> document.getElementById("div1");
//     if (inputChars==0)
//     {
//       //swal("Warning!","Coming Here");      
//       element1.innerText="Please enter valid Account Head";
//       this.formSubmitted=true;
//     }
//     else
//     {
//       element1.innerText="";
//     }
//     if (!pattern.test(inputChar)) 
//     {       
//       event.preventDefault();
//     }
//  }
  // Reset(accountHeadForm)
  // {
  //   accountHeadForm.reset();
  // }
  GetAccountHeadForAccountId(AccountHead)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getAccountForAccountHead(this.AccountHead)
      .subscribe(
        (data) => {
          //this.AccountHeadDetails = data;  
          this.a= data;  
          this.SubHeadGridList= this.a.AccountSubHeadDetails;
          console.log('subheadlist',this.SubHeadGridList);     
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  // UpdateAccountHead(form)
  // {
  //   ;
    // var accountHeadText = <HTMLInputElement>document.getElementById("txtAccountHead")
    // let inputChars = new Number(accountHeadText.value);
    // var element1 = <HTMLDivElement> document.getElementById("div1");
    // if (inputChars==0)
    // {      
    //   element1.innerText="Please enter valid Account Head";
    //   form.invalid=true;
    // }
    // else
    // {
    //   element1.innerText="";
    // }
  //   if (!form.invalid) 
  //   {              
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.userService.updateAccountHead(this.AccountHeadDetails).subscribe(
  //     (data:any) => {
  //       ;
  //       document.getElementById('loader-spinner').style.display = "none";
  //       swal('','Account Head Updated Successfully!','success');
  //       this.router.navigate(['/home/accounthead']);          
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display="none";
  //         this.errorHandler.HandlerError(error);
  //       });
  //     }
  //     else
  //     {
  //       this.formSubmitted = true;
  //     }
  // }

 AddTogrid(a)
 {
  if (a.AccountSubHead==undefined || a.AccountSubHead==null) {
  //swal("Please select the account head"); 
  swal("Please fill the subhead details");  
   }
  else
   {
    let temp = {
      AccountHead: a.AccountHead,
      AccountSubHead:a.AccountSubHead,
      SubHeadName:a.SubHeadName,
      OpeningBalance : a.OpeningBalance,
      SubAcc_Id:a.SubAcc_Id,
    }
    this.SubHeadGridList.push(temp);
    console.log(this.SubHeadGridList);
    this.a.AccountSubHead="";
    this.a.SubHeadName="";
    this.a.OpeningBalance="";
    this.a.SubAcc_Id="";
   }
  }

  closeModalDialog(){
    $("#accountHeadModal").modal('hide'); 
   }

  //Accounthead save
  Save(form)
  {
    //var accountHeadText = <HTMLInputElement>document.getElementById("txtAccountHead")
    //let inputChars = new Number(accountHeadText.value);
    //var element1 = <HTMLDivElement> document.getElementById("div1");
   // if (inputChars==0)
   // {      
     // element1.innerText="Please enter valid Account Head";
     // form.invalid=true;
  //  }
    // else
    // {
    //   element1.innerText="";
    // }

    if (!form.invalid) 
    {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.addAccountHead(this.s).subscribe(
      (data:any) => {
        document.getElementById('loader-spinner').style.display = "none";
        //swal('','Account head Added Successfully!','success');
        swal('','Account head Saved Successfully!','success');
        this.s={};
        this.s.isChecked=false;
        //this.checked=false;
        this.closeModalDialog();
        this.GetAllAccountHeads();
        //this.router.navigate(['/home/accounthead']);
        
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });        
    }
  
    else
    {
      this.formSubmitted = true;
    }
  }


  //account head dropdown
  GetAllAccountHeads()
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllAccountHeadValues()
    .subscribe(
      (data) => {
        this.accountHeadlist = data;
        console.log(this.accountHeadlist);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }



  SaveSubHeadDetails(form)
  { 
    // var accountSubHeadText = <HTMLInputElement>document.getElementById("txtSubHeadName")
    // let inputChars = new Number(accountSubHeadText.value);
    // var element1 = <HTMLDivElement> document.getElementById("div1");
    // if (inputChars==0)
    // {      
    //   element1.innerText="Please enter valid Account Sub Head";
    //   form.invalid=true;
    // }
    // elseSave
    // {
    //   element1.innerText="";
    // }
    if(this.SubHeadGridList.length!=null|| this.SubHeadGridList.length!=undefined )
    {
    // if (!(form.invalid))
    // {
     document.getElementById('loader-spinner').style.display = "block";
    
     
    //  for (let i = 0; i < this.SubHeadGridList.length; i++) {
    //   regForm.value.AccountHead=this.SubHeadGridList[i].AccountHead;
    //   regForm.value.AccountSubHead=this.SubHeadGridList[i].AccountSubHead;
    //   regForm.value.SubHeadName=this.SubHeadGridList[i].SubHeadName;
    //   r.value.ACC_Id=this.SubHeadGridList[i].ACC_Id;
    // }
   //  this.r.accountSubHeadModel=this.SubHeadGridList;
        this.userService.addAccountSubHead(this.SubHeadGridList).subscribe(
        (data:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          //swal('','Account sub head Added Successfully!','success');
          swal('','Account sub head Saved Successfully!','success');
          this.router.navigate(['/home/accounthead']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
      else
      {
        swal('Warning!',"Please select atleast one subhead",'warning');
        this.formSubmitted = true;
      }
  }



  //UpdateSubheadDetails
  UpdateAccountSubHeadDetails(form)
  {
    ;
    // var accountSubHeadText = <HTMLInputElement>document.getElementById("txtSubHeadName")
    // let inputChars = new Number(accountSubHeadText.value);
    // var element1 = <HTMLDivElement> document.getElementById("div1");
    // if (inputChars==0)
    // {      
    //   element1.innerText="Please enter valid Account Sub Head";
    //   form.invalid=true;
    // }
    // else
    // {
    //   element1.innerText="";
    // }
      // if (!(form.invalid))
      // {
        if(this.SubHeadGridList.length!=0 && this.a.AccountHead!=null||this.a.AccountHead!=undefined)
        {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.updateAccountSubHead(this.SubHeadGridList).subscribe(
        (data:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Account Sub Head Updated Successfully!','success');
          this.router.navigate(['/home/accounthead']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
      else
      {
        swal('Warning!',"Please select accound head and atleast one subhead",'warning');
        this.formSubmitted = true;
      }
    }


     //For edit
  openModalDialog(i) {
    this.EditSubHead(i);
  }

  EditSubHead(i){
    this.edit=1;
    this.a.AccountSubHead=this.SubHeadGridList[i].AccountSubHead;
    this.a.SubHeadName=this.SubHeadGridList[i].SubHeadName;
    this.a.OpeningBalance=this.SubHeadGridList[i].OpeningBalance;
    this.a.SubAcc_Id =this.SubHeadGridList[i].SubAcc_Id;
    // this.fd = this.FamilyDetails[i];
    // this.fd.j=i;
    // this.fd.relationid = this.GetRelationId(this.fd.relationName);
    // this.fd.qualificationid = this.GetQualifactionId(this.fd.SD_Qualification)
    // this.fd['SD_DOB'] = ((this.FamilyDetails[i].SD_DOB).split('T'))[0];
    //this.fd['SD_Qualifictaion']=this.FamilyDetails[i].Qualifications.Q_Id;
      this.RemoveSubHead(i);  
    //this.closeModalDialog();
  }

    //for edit
  RemoveSubHead(i) {
    this.SubHeadGridList.splice(i, 1);
  }


 //Delete subhead
  DeleteAccountSubHead(i)
  {
        var SubheadId = this.SubHeadGridList[i].AccountSubHead;
        var accountHead= this.a.AccountHead;
        if(SubheadId==undefined || SubheadId==0)
        {
          this.SubHeadGridList.splice(i, 1);
        }
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteAccountSubHead(accountHead,SubheadId).subscribe(
          (data:any) => {
            swal('','Subhead Deleted!','success');
            this.SubHeadGridList.splice(i, 1);
            document.getElementById('loader-spinner').style.display="none";
            //this.GetAllDistricts(this.itemsPerPage, 1);
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            if(this.SubHeadGridList!=0)
            this.SubHeadGridList.splice(i, 1);
            this.errorHandler.HandlerError(error);
          });
      }
    })     
  } 




  NoSubHeadsCheckHere()
  {
    this.a.AccountSubHead=this.s.AccountHead;
    this.a.SubHeadName=this.s.AccountName;
  }




  }



// WEBPACK FOOTER //
// ./src/app/Finance/account-head/account-head.component.ts